module.exports = __webpack_public_path__ + "img/img4.eb2d7d3b.png";